import {get,post} from '../index'
export const getInvoice={
    // 发票列表
    getInvoiceList(params){
        return get('invoice/list',params)
    },
    // 发票信息
    getDetail(params){
        return get('invoice/detail',params)
    },
      // 申请发票
      getInvoiceDilling(params){
        return post('invoice/billing',params)
    }
}


// WEBPACK FOOTER //
// ./src/api/http/invoice.js